import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'
import { AccountDetailsLink } from '../Shared'

export const StyledAccountDetailsLink = styled(AccountDetailsLink)`
  width: 100%;
  justify-content: flex-start;
`

export const TotalBalanceContainer = styled(Box)`
  ${({ theme: { space, colors } }): string => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space.sm};
`};
`
